export interface ISortOption {
  value: unknown;
  label: string;
  icon?: string;
  img?: string;
  imgClass?: string;
  iconColour?: string;
  image?: string;
  svgIcon?: string;
  svgClass?: string;
  svgStyle?: string;
  svgFill?: boolean;
  svgStroke?: boolean;
}

export interface ISortMainImage {
  src: string;
  maxWidth: number;
}

export enum SortOrder {
  Ascending = 1,
  Descending = 2,
}
